/**
 * Use Case: Criar Usuário
 * Orquestra a criação de um novo usuário do CRM
 */

import { IUserRepository } from '../../../domain/repositories/IUserRepository';
import { User } from '../../../domain/entities/User';

export interface CreateUserDTO {
    name: string;
    email: string;
    role: 'admin' | 'agent';
}

export class CreateUserUseCase {
    constructor(private readonly userRepository: IUserRepository) { }

    async execute(dto: CreateUserDTO): Promise<User> {
        // Gera ID temporário (será substituído pelo UUID do Supabase)
        const tempId = `temp_${Date.now()}`;

        // Cria entidade (validações automáticas)
        const user = new User(
            tempId,
            dto.name,
            dto.email,
            dto.role,
            new Date() // lastAccess será a data de criação
        );

        // Persiste no repositório
        await this.userRepository.save(user);

        return user;
    }
}
